import { defineComponent } from "vue";
import emojiPC from "../EditorTools/emojiPC.vue.mjs";
import useChatEditor from "./useChatEditor.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ChatEditorPC",
  setup(__props) {
    const {
      t,
      editorInputEle,
      sendMsg,
      isMessageDisabled,
      sendMessage,
      handleChooseEmoji
    } = useChatEditor();
    return { __sfc: true, t, editorInputEle, sendMsg, isMessageDisabled, sendMessage, handleChooseEmoji, emoji: emojiPC };
  }
});
export {
  _sfc_main as default
};
